import * as React from "react";
import { formatMessage } from "lib/globalize-util";
import theme from "styles/theme";
import { DATATEST } from "constants/integration";
import { Link, mergeStyleSets } from "@nuorder/components";

interface IProps {
    isRollupMode: boolean;
    readOnly?: boolean;
    onExportDataAsExcel: () => void;
}
export const ManageAllocationDimensionDescription: React.FunctionComponent<IProps> = ({
    isRollupMode,
    readOnly,
    onExportDataAsExcel,
}) => {
    const classes = React.useMemo(
        () =>
            mergeStyleSets({
                modalDescriptionContainer: {
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    margin: "15px 0",
                },
                modalDescription: {
                    fontSize: 14,
                    color: theme.palette.darkGrey,
                },
                exportLink: {
                    color: theme.palette.textColor,
                    fontSize: 12,
                    marginLeft: 20,
                    textAlign: "center",
                    "&:hover": {
                        color: theme.palette.textColor,
                    },
                },
            }),
        []
    );

    return (
        <div className={classes.modalDescriptionContainer}>
            <p className={classes.modalDescription}>
                {isRollupMode
                    ? formatMessage(
                          "These default attributes are assigned to your stores to organize them into clusters and channels within this Rollup."
                      )
                    : formatMessage(
                          "Assign groupings to your stores to organize them into clusters and channels within this Assortment."
                      )}
            </p>
            {!readOnly && (
                <Link
                    underline
                    disabled={readOnly}
                    onClick={onExportDataAsExcel}
                    className={classes.exportLink}
                    data-test={DATATEST.ASSORTMENTS.ALLOCATION_DIMENSIONS.EXPORT_BTN}
                >
                    {formatMessage("Export door attributes")}
                </Link>
            )}
        </div>
    );
};
